module.exports = __webpack_public_path__ + "7111b15215671c0cabae683635bd2bed.svg";